import SCTranslations from '../../../components/simpleCrud/SCTranslations.class';
import { SimpleCrudController } from '../../../components/simpleCrud/simpleCrud.controller';
import Field, {
  FieldApparence
} from '../../../components/simpleCrud/field.class';

interface Product {
  name: String;
  info: String;
  price: Number; // prezzo in euro
}

export default class ProductsController extends SimpleCrudController {
  model: Product = {
    name: '',
    info: '',
    price: 0
  };
  fields = [
    new Field('name', 'text'),
    new Field('info', 'text', {
      apparence: new FieldApparence({ fullwidth: true })
    }),
    new Field('price', 'number')
  ];
  errors = {};
  submitted = false;

  translations: SCTranslations = new SCTranslations({
    listTitle: 'LBL_PRODUCTS',
    // newTitle: 'LBL_NEW_ASSISTANT',
    listIsEmpty: 'LBL_NO_PRODUCTS_FOUND',
    newTitleNoData: 'LBL_FIRST_NEW_PRODUCT'
  });

  /*@ngInject*/
  constructor(Product, $timeout) {
    super($timeout);
    this.service = Product;
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/products/products.controller.ts